import { render } from "./DiceD20Icon.vue?vue&type=template&id=0648afe6&scoped=true"
const script = {}

import "./DiceD20Icon.vue?vue&type=style&index=0&id=0648afe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0648afe6"]])

export default __exports__